import React from 'react';

import { Box } from '@mui/material';
import { connect } from 'react-redux';
import Permissions from 'react-redux-permissions';
import { compose } from 'recompose';

import { EFieldType } from '../../../../models/EFieldType';
import { FkSwitch } from '../../../../ui/FkSwitch/FkSwitch';
import StaffOnlyFormItemLayout from '../components/StaffOnlyFormItemLayout';

type OuterProps = {};
type Props = OuterProps;

const ArchivedField = () => {
  return (
    <Permissions allowed={['FlipdishStaff']}>
      <StaffOnlyFormItemLayout labelId="Archived">
        <Box display="flex" alignItems="center" height="100%">
          <FkSwitch
            required={false}
            fieldType={EFieldType.Boolean}
            name="isArchived"
            fdKey="isArchived"
          />
        </Box>
      </StaffOnlyFormItemLayout>
    </Permissions>
  );
};

export default compose<OuterProps, OuterProps>(connect())(ArchivedField);
